// import Rectangle84 from "../../assets/img/Rectangle84.png";
// import profileImage from '../../assets/img/profile-image.jpg';
// import Rectangle89 from "../../assets/img/Rectangle91.png";
// import icon from "../../assets/img/icon.png";
// import Co/mmentItem from "./CommentItem";
import React, { useState } from 'react';
import hooks from "./ChangePasswordHook";
import LoginInputs from "../../components/TextInput/LoginInputs/LoginInputs";
import ClipLoader from "react-spinners/ClipLoader";
import validation from "../../utils/validation";
import styles from "./ChangePassword.module.scss";
import { useTranslation } from 'react-i18next';
import ModalComp from '../../components/ModalComp/ModalComp';
import MainButton from '../../components/ButtonsCont/MainButton';
// "./changePhone.module.scss";

function ChangePassword(props) {
    const {
        enterOldPassword,
        enterPassword,
        change_password,
        keyPress,
        handleOpen,
        handleClose,
        handleSubmited,
        loading,
        submited,
        open,
        oldPassword,
        password
    } = hooks(props);
    const { t } = useTranslation();

    const body = (
        <div>
            <div className="">
                <div className={styles.passwordInput}>
                    <LoginInputs
                        type='password'
                        placeholder={t("oldPassword")}
                        valid={oldPassword.valid}
                        value={oldPassword.value}
                        submitted={submited}
                        error_message={t("error_passsword")}
                        onKeyDown={(e) => keyPress(e)}
                        onChange={(value) => { enterOldPassword(validation({ value, type: "password" })); }} />
                </div>
                <div className={styles.passwordInput}>
                    <LoginInputs
                        type='password'
                        placeholder={t("passwordLabel")}
                        valid={password.valid}
                        value={password.value}
                        submitted={submited}
                        error_message={t("error_passsword")}
                        onKeyDown={(e) => keyPress(e)}
                        onChange={(value) => { enterPassword(validation({ value, type: "password" })); }} />
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <MainButton onClick={() => change_password()} title={loading
                    ? <ClipLoader color="#464646" size={15} />
                    : "Сохранить"} />
            </div>
        </div>
    );
    return (
        <>
            <ModalComp body={body} open={open} setValue={handleClose} />
            <div onClick={handleOpen} className={styles.changePasswordLabel}>{t('changePassword')}</div>
        </>
    );
}
export default ChangePassword;